import { render, staticRenderFns } from "./EducationProtocol.vue?vue&type=template&id=42e3c708&"
import script from "./EducationProtocol.vue?vue&type=script&lang=ts&"
export * from "./EducationProtocol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports